import MarkdownPreview from './MarkdownPreview.vue'

export default function (Vue, options = {}) {
    Vue.component('markdown-preview', MarkdownPreview);
}
